var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-page',[_c('empty-state',{attrs:{"icon":"group_work","title":"No groups found","description":"To start using dashboards, create or join a group from your PioneerRx software"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }